import { Image } from "@fluentui/react";
import NoFlightsIcon from "../../common/images/no-flights.svg";

export const NoDataCard: React.FunctionComponent<IFlightNoDataProps> = (
  props: IFlightNoDataProps
) => {
  const containerClassName = props.marginAll
    ? "text-c margin-auto-all"
    : "text-c margin-auto";

  return (
    <div data-testid="no-data" className={containerClassName}>
      {!props.hideImage && (
        <Image
          style={noFlightsImageStyles}
          src={NoFlightsIcon}
          alt="No data"
        ></Image>
      )}
      <div style={noFlightMessageStyles}>{props.message}</div>
    </div>
  );
};

export interface IFlightNoDataProps {
  message: string;
  marginAll?: boolean;
  hideImage?: boolean;
}

const noFlightsImageStyles: React.CSSProperties = {
  paddingTop: "25px",
  margin: "auto",
};

const noFlightMessageStyles: React.CSSProperties = {
  fontSize: "14x",
  fontWeight: "600",
  paddingTop: "10px",
};
